import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function WhatsInside() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const chapters = [{
    emoji: '📗',
    color: 'green',
    title: 'CAPÍTULO 1',
    ages: 'Edades 2-5',
    subtitle: 'Early Skills / Habilidades Tempranas',
    activities: ['Colorear Libre (Free Coloring)', 'Unir Puntos (Connect the Dots)', 'Animales para Colorear (Animal Coloring)']
  }, {
    emoji: '📘',
    color: 'blue',
    title: 'CAPÍTULO 2',
    ages: 'Edades 6-9',
    subtitle: 'Brain Challenges / Desafíos Cognitivos',
    activities: ['Laberintos (Fun Mazes)', 'Buscar Diferencias (Spot the Difference)', 'Colorear por Números (Color by Numbers)']
  }, {
    emoji: '📙',
    color: 'orange',
    title: 'CAPÍTULO 3',
    ages: 'Edades 10-12',
    subtitle: 'Advanced Skills / Habilidades Avanzadas',
    activities: ['Sopas de Letras (Word Search)', 'Mandalas Infantiles (Kids Mandalas)', 'Copiar Dibujos (Copy the Drawing)']
  }];
  const colorClasses = {
    green: 'from-green-50 to-green-100 border-green-300',
    blue: 'from-blue-50 to-blue-100 border-blue-300',
    orange: 'from-orange-50 to-orange-100 border-orange-300'
  };
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-143">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-144">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 text-center mb-12" data-id="element-145">
          TODO lo que viene en el libro:
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-146">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.2 * index,
          duration: 0.6
        }} className={`bg-gradient-to-br ${colorClasses[chapter.color as keyof typeof colorClasses]} border-2 p-6 rounded-3xl shadow-lg`} data-id="element-147">
              <div className="text-5xl mb-4" data-id="element-148">{chapter.emoji}</div>
              <h3 className="font-fredoka text-xl font-bold text-gray-900 mb-1" data-id="element-149">
                {chapter.title}
              </h3>
              <p className="font-nunito text-sm font-semibold text-gray-700 mb-2" data-id="element-150">
                {chapter.ages}
              </p>
              <p className="font-nunito text-base font-bold text-gray-800 mb-4" data-id="element-151">
                {chapter.subtitle}
              </p>
              <ul className="space-y-2" data-id="element-152">
                {chapter.activities.map((activity, i) => <li key={i} className="flex items-start" data-id="element-153">
                    <span className="text-gray-600 mr-2" data-id="element-154">•</span>
                    <span className="font-nunito text-sm text-gray-700" data-id="element-155">
                      {activity}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}